import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/**
 * External dependencies
 */
import { useContext, useEffect, useMemo, useState } from 'react';
import useFetch from '../hooks/useFetch';
import useMap from '../hooks/useMap';
import useWindowSize from '../hooks/useWindowSize';
import { ADD_TO_VISIBLE, SET_FILTERED_POSTS, SET_POSTS, store } from '../state/state';
import Card from './Card';
import { latitudeSort } from './ExplorerMap';
import Filters from './Filters';
import Footer from './Footer';
import IconSprite from './IconSprite';
import Map from './Map';
import MapUI from './MapUI';
import { motion } from 'framer-motion';
import Spinner from './Spinner';
const url = `${window.mainSiteData.root}scenic-rim/v2/listings?`;
const Listings = ({ accessibility, categories, category, organisations, date, showMap, postType, postIn, region, regions, search, title, searchPlaceholder, sort, accreditation }) => {
    const { height } = useWindowSize();
    const { ref, map, loaded: mapLoaded } = useMap();
    const [loading, setLoading] = useState(true);
    const [route, setRoute] = useState(null);
    const globalState = useContext(store);
    const { state, dispatch } = globalState;
    const { filteredPosts = [], visible } = state;
    const visibleFilteredPosts = useMemo(() => {
        return filteredPosts.slice(0, visible);
    }, [filteredPosts, visible]);
    const filterParams = useMemo(() => ({
        nonce: window.mainSiteData.nonce,
        postType,
        ...(category && { categories: category }),
        ...(region && { region }),
        ...(postIn && { postIn }),
        ...(organisations && { organisations }),
        ...(accreditation && { accreditation })
    }), [postType, postIn]);
    // Fetch listings
    const { data, error } = useFetch(url + new URLSearchParams(filterParams), {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'X-WP-Nonce': window.mainSiteData.nonce
        }
    });
    // Update fetched listings in state
    useEffect(() => {
        if (!error && data) {
            setLoading(false);
            dispatch({
                type: SET_POSTS,
                posts: data?.posts || []
            });
        }
        else if (error) {
            // Handle error
        }
        else {
            setLoading(true);
        }
    }, [data, dispatch, setLoading]);
    // Update filtered posts when posts are stored in state
    useEffect(() => {
        dispatch({
            type: SET_FILTERED_POSTS,
            ...state,
            filteredPosts: state.posts
        });
    }, [state.posts, dispatch]);
    // Handle map data
    useEffect(() => {
        if (!visibleFilteredPosts.length) {
            return;
        }
        setRoute({
            path: 'places',
            meta: {
                title: 'Places to visit',
                variant: 'blue',
                homeCard: false,
                layer: {
                    title: 'Title',
                    intro: 'Intro',
                    icon: 'mountain',
                    posts: latitudeSort(visibleFilteredPosts)
                },
            },
        });
    }, [visibleFilteredPosts, setRoute, latitudeSort]);
    const loadMore = () => dispatch({ type: ADD_TO_VISIBLE, visible });
    const mapStyle = state.showMap
        ? { opacity: 1, visibility: 'visible', height: 'auto' }
        : { opacity: 0, visibility: 'hidden', height: 0, marginTop: '0px' };
    return (_jsxs(_Fragment, { children: [_jsx(IconSprite, {}), _jsxs("section", { className: "relative space-y-8", children: [!loading && title && _jsx("header", { className: "relative corridor", children: _jsx("h2", { className: "text-black", dangerouslySetInnerHTML: { __html: title } }) }), !loading && _jsx(Filters, { accessibility: accessibility, categories: categories, date: date, map: showMap, regions: regions, search: search, searchPlaceholder: searchPlaceholder, postType: postType, sort: sort }), showMap && _jsx("div", { style: mapStyle, children: _jsxs("div", { className: "relative w-full bg-grey-100", style: { height: height + 'px' }, children: [_jsx(Map, { mapRef: ref, loaded: mapLoaded }), mapLoaded && route && _jsx(MapUI, { map: map, routes: [route] })] }) }), loading ? (_jsx(motion.div, { exit: { opacity: 0, height: 0 }, className: "absolute inset-0 flex items-center justify-center h-full pointer-events-none", children: _jsx(Spinner, { size: "lg", color: "gold" }) })) : (!state.showMap &&
                        _jsxs(_Fragment, { children: [state.filteredPosts.length !== 0 ? (_jsx("div", { className: `base-grid transition-all${state.filtering ? ' opacity-20' : ''}`, children: visibleFilteredPosts.map((post, i) => (_jsx("div", { className: "col-span-full tablet-portrait:col-span-4 tablet-landscape:col-span-4", children: _jsx(Card, { id: post.id, title: post.title, subtitle: post?.subtitle, categories: post?.types, tag: post?.tag, postType: post.postType, permalink: post.link, icon: post?.icon, thumbnail: post.image, excerpt: post.excerpt }) }, i))) })) : (_jsx("div", { className: "flex flex-col items-center py-20 corridor tablet-landscape:py-24 laptop:py-30", children: _jsx("h4", { className: "max-w-xl text-center text-black", children: "While there's many things to do in the Scenic Rim, we can't find an exact match for you, perhaps try widening your search?" }) })), state.visible < state.filteredPosts.length && (_jsx(Footer, { onClick: loadMore }))] }))] })] }));
};
export default Listings;
